<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>
<span style="font-size: 0.8rem;" class="footer">v{{version}}</span>



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/app.component.html